import { render } from "./ChatbotChoresEvents.vue?vue&type=template&id=5050eb08&scoped=true"
import script from "./ChatbotChoresEvents.vue?vue&type=script&lang=js"
export * from "./ChatbotChoresEvents.vue?vue&type=script&lang=js"

import "./ChatbotChoresEvents.vue?vue&type=style&index=0&id=5050eb08&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5050eb08"]])

export default __exports__